module.exports = __webpack_public_path__ + "img/pt.080c185f.svg";